import PortalLayout from "layout/portallayout";
import AdministrationLayout from "layout/administrationlayout";
import { Routes } from "./types";

const routes: Routes[] = [
    // {
    //   path: "/portal",
    //   component: PortalLayout,
    //   breadcrumbs: [{ url: "", label: "app.Routes.Hierarchy" }],
    //   exact: true,
    //   requiredRoles: [],
    //   routes: [],
    // },
    {
        path: "/administration/*",
        component: AdministrationLayout,
        breadcrumbs: [],
        exact: true,
        requiredRoles: [],
        routes: [],
    },
];

export { routes };
